var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 23.9855C8.83456 23.9951 8.66785 24 8.5 24C3.80558 24 0 20.1944 0 15.5C0 10.8056 3.80558 7 8.5 7C8.58366 7 8.66703 7.00121 8.75011 7.00361C10.0833 4.05315 13.0519 2 16.5 2C20.6857 2 24.1648 5.02552 24.8697 9.00895C28.8401 9.20166 32 12.4818 32 16.5C32 20.6421 28.6421 24 24.5 24C24.332 24 24.1653 23.9945 24 23.9836V24H9V23.9855Z",
    fill: "#647FB4",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21L16 15M16 15L22 21M16 15L16 30",
    stroke: "#647FB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.e24a58dbc006c47f8083dfdf6f403a16.svg";
export { ForwardRef as ReactComponent };